import { Module } from 'wrapper6';
import $ from 'jquery';

export default class StepGuide extends Module {
	ready() {

        // get all step guide wrappers
        const WRAPPERS = document.querySelectorAll('.step-guide');

        // init all
        if (WRAPPERS.length) {
            for (let i = 0; i < WRAPPERS.length; i++) {
                new StepGuideSlider( WRAPPERS[i] );
            }
        }
    }
}

class StepGuideSlider {

    constructor(selector) {

        // get elements
        this.CONTAINER = selector;
        this.SLIDER_ELEMENTS = selector.querySelectorAll('.swiper-container');
        this.CATEGORIES = selector.querySelectorAll('.step-guide__category');
        this.WRAPPERS = selector.querySelectorAll('.step-guide__swiper-wrap');
        this.SLIDERS = [];
        this.active_slider = 0;

        if (this.SLIDER_ELEMENTS.length) {
            for (let i = 0; i < this.SLIDER_ELEMENTS.length; i++) {
                
                // init slider
                const SLIDER = new Swiper(`.swiper-container${i}`, {
                    speed: 600,
                    slidesPerView: 1,
                    loop: false,
                    centeredSlides: false,
                    grabCursor: true,
                    observer: true,
                    observeParents: true,
                    pagination: {
                        el: this.CONTAINER.querySelector(`.swiper-pagination${i}`),
                        type: 'bullets',
                        clickable: true
                    },
                });

                this.SLIDERS.push(SLIDER);

                //////////////////////////////////////////////////////////
                // on slide change
                //////////////////////////////////////////////////////////
                SLIDER.on('slideChange', () => {

                    const STEPS = this.WRAPPERS[this.active_slider].querySelectorAll('.step-guide__step');
                    const STEP = STEPS[ this.SLIDERS[this.active_slider].activeIndex ];
                    const INDEX = this.SLIDERS[this.active_slider].activeIndex;

                    // update steps
                    this.changeStep(STEPS, STEP, INDEX);

                });
            }
        }

        // check if categories and wrappers are present
        if (this.CATEGORIES.length && this.WRAPPERS.length) {
            this.eventListeners();
        }
    }

    /**
     * Handler for event listeners
     */
    eventListeners() {

        //////////////////////////////////////////////////////////
        // click on category
        //////////////////////////////////////////////////////////
        for (let i = 0; i < this.CATEGORIES.length; i++) {
            
            const CATEGORY = this.CATEGORIES[i];
            const INDEX = i;

            CATEGORY.addEventListener('click', () => {

                // update active slider
                this.active_slider = INDEX;

                // remove all active classes
                for (let i = 0; i < this.CATEGORIES.length; i++) {
                    this.CATEGORIES[i].classList.remove('active');
                }

                // set current as active
                CATEGORY.classList.add('active');

                // hide all wrappers
                for (let i = 0; i < this.WRAPPERS.length; i++) {
                    this.WRAPPERS[i].classList.remove('active');
                }

                // show correct wrapper 
                this.WRAPPERS[ INDEX ].classList.add('active');

                // reset slider
                this.resetSlider();

            });
        }

        //////////////////////////////////////////////////////////
        // update slider when clicking on step
        //////////////////////////////////////////////////////////
        for (let i = 0; i < this.WRAPPERS.length; i++) {
            
            const WRAPPER = this.WRAPPERS[i];
            const STEPS = WRAPPER.querySelectorAll('.step-guide__step');

            if (STEPS) {
                for (let i = 0; i < STEPS.length; i++) {
                    
                    const STEP = STEPS[i];
                    const INDEX = i;

                    STEP.addEventListener('click', () => {

                        // update steps
                        this.changeStep(STEPS, STEP, INDEX);

                        // update slider
                        this.SLIDERS[this.active_slider].slideTo(INDEX);

                    });
                }
            }
        }
    }

    changeStep(STEPS, STEP, INDEX) {

        // remove all active and activated steps 
        for (let i = 0; i < STEPS.length; i++) {
            STEPS[i].classList.remove('active');
            STEPS[i].classList.remove('activated');
        }

        // set activated class for steps
        for (let i = 0; i < STEPS.length; i++) {
            STEPS[i].classList.add('activated');
            if (i == INDEX) break;
        }

        // set current as active
        if (STEP)
            STEP.classList.add('active');

    }

    resetSlider() {

        for (let i = 0; i < this.WRAPPERS.length; i++) {
            
            const WRAPPER = this.WRAPPERS[i];
            const STEPS = WRAPPER.querySelectorAll('.step-guide__step');
    
            // reset all steps
            for (let i = 0; i < STEPS.length; i++) {
                STEPS[i].classList.remove('active');
                STEPS[i].classList.remove('activated');
            }

            // set first step as active
            STEPS[0].classList.add('active');
            STEPS[0].classList.add('activated');

            // slide to first
            this.SLIDERS[this.active_slider].slideTo(0);
        }
    }
}


// WEBPACK FOOTER //
// ./resources/js/modules/_step-guide.js